import { FieldMetaProps } from "formik";

export default function DisplayError({
  meta,
}: {
  meta: FieldMetaProps<string>;
}) {
  return <span>{meta.error}</span>;
}
